import bee from "./Bee"
export default {
    name: "Businesses",
    /*
        var query = {
            
        }
    */
    /* eslint-disable no-unused-vars */
    get_number_of_businesses(query, success, fail) {
        //nyd 
        //for now just do this
        bee.get({
            businesses: {
                _a: "_count"
            }
        })
            .then(res => {
                if (success) {
                    var num = res.businesses[0].count;//24567; 
                    success(num);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            user_id: 2
        }
    */
    /* eslint-disable no-unused-vars */
    get_my_buinesses(query, success, fail) {
        bee.get({
            businesses: {
                district: {},
                _ob: ["name"],
                _w: [
                    ["user_id", "e", query.user_id]
                ]
            }
        }).then(res => {
            if (success) {
                success(res.businesses);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            user_id: 2
        }
    */
    /* eslint-disable no-unused-vars */
    get_my_missing_info_report(query, success, fail) {
        bee
            .get({
                businesses: {
                    belongings: {},
                    business_holliday_schedules: {},
                    pictures: {},
                    products: {},
                    services: {},
                    _w: [
                        ["user_id", "e", query.user_id]
                    ]
                },
                hollidays: {
                    _w: [
                        ["country_id", "e", 1] //country botswana
                    ]
                }
            })
            .then(res => {
                if (success) {
                    success({
                        businesses: res.businesses,
                        hollidays: res.hollidays
                    });
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    get_admin_missing_info_report(query, success, fail) {
        bee
            .get({
                businesses: {
                    belongings: {},
                    business_holliday_schedules: {},
                    pictures: {},
                    products: {},
                    services: {}
                },
                hollidays: {
                    _w: [
                        ["country_id", "e", 1] //country botswana
                    ]
                }
            })
            .then(res => {
                if (success) {
                    success({
                        businesses: res.businesses,
                        hollidays: res.hollidays
                    });
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    get_admin_business_missing_info_report(query, success, fail) {
        bee
            .que()
            .get({
                businesses: {
                    user: {},
                    district: {},
                    city: {},
                    ward: {},
                    street: {},
                    belongings: {},
                    business_holliday_schedules: {},
                    pictures: {},
                    products: {},
                    services: {},
                    _w: [
                        ["id","e", query.id]
                    ]
                },
                hollidays: {
                    _w: [
                        ["country_id", "e", 1] //country botswana
                    ]
                }
            },"get_business")
            .get({},
                "get_parent_branch_business"
            )
            .before("get_parent_branch_business", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (parseInt(previous_res.businesses[0].is_branch_of_id) > 0) {
                    return {
                        business: {
                            _w: [
                                ["id", "e", previous_res.businesses[0].is_branch_of_id]
                            ]
                        }
                    };
                }
                return "skip";
            })
            .send()
            .then(res => {
                if (success) {
                    var b_res = res[0].response;
                    var p_branch = null;
                    if (res[1].response._skipped && res[1].response._skipped == true) {
                        //do nothing for now
                    } else {
                        p_branch = res[1].response.business;
                    }
                    b_res.businesses[0]["parent_branch"] = p_branch;
                    success({
                        businesses: b_res.businesses,
                        hollidays: b_res.hollidays
                    });
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            user_id: 2
        }
    */
    /* eslint-disable no-unused-vars */
    get_register_business_dependencies(query, success, fail) {
        bee.get({
            businesses: {
                _ob: ["name"],
                _w: [
                    ["user_id", "e", query.user_id]
                ]
            },
            districts: {
                cities: {},
                wards: {
                    streets: {}
                }
            },
            categories: {
                sub_categories: {}
            }
        }).then(res => {
            if (success) {
                success({
                    businesses: res.businesses,
                    districts: res.districts,
                    categories: res.categories
                });
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            data: {},
            categories: [],
            is_added_by_admin: true
        }
    */
    /* eslint-disable no-unused-vars */
    post_my_business(query, success, fail) {
        var blngs = [];
        for (let index = 0; index < query.categories.length; index++) {
            var cat = query.categories[index];
            blngs.push({
                _fk_business_id: "business",
                sub_category_id: cat.id,
                category_id: cat.category_id,
                country_id: 1 //botswana
            });
        }
        //var msg_id = Math.random().toString().replace("0","") + "_" + (new Date()).getTime().toString();
        var data = {
            business: query.data,
            belongings: blngs
        };
        bee.post(data).then(res => {
            //send success messages and mobile phone android and ios notifications
            var message_data = {
                _box: {
                    user_id: query.data.user_id,
                    business_id: res.business,
                    is_added_by_admin: query.is_added_by_admin,
                    business_name: query.data.name
                },
                _f_br: "send_registration_success_messages"
            }
            bee.get(message_data).then(res2 => {
                if (success) {
                    success({
                        business: res.business,
                        belongings: res.belongings,
                        ...res2
                    });
                }
            }).catch(errors => {
                fail(["Business was registered but we faced errors while sending you messages"].concat(errors));
            });
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    update_my_business(query, success, fail) {
        var blngs = [];
        for (let index = 0; index < query.categories.length; index++) {
            var cat = query.categories[index];
            blngs.push({
                business_id: query.id,
                sub_category_id: cat.id,
                category_id: cat.category_id,
                country_id: 1 //botswana
            });
        }

        //we need to first delete all former belongings for this business
        bee
            .que()
            .delete({
                belongings: {
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                }
            }, "remove_belongings")
            .update({
                business: {
                    ...query.data,
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            }, "update_business")
            .post({
                belongings: blngs
            }, "insert_belongings")
            .send()
            .then(res => {
                if (success) {
                    success(res[1].response.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            user_id: 2,
            id: 34
        }
    */
    /* eslint-disable no-unused-vars */
    get_my_business(query, success, fail) {
        bee.que()
            .get({
                business: {
                    user: {},
                    district: {},
                    city: {},
                    ward: {},
                    street: {},
                    _w: [
                        ["id", "e", query.id]
                    ]
                },
                belongings: {
                    sub_category: {},
                    category: {},
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                business_holliday_schedules: {
                    holliday: {},
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                pictures: {
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                reviews: {
                    user: {},
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                ratings: {
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                products: {
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                services: {
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                business_messages: {
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                },
                hollidays: {
                    _w: [
                        ["country_id", "e", 1] //country botswana
                    ]
                },
                // _sql: {}
            }, "get_my_business")
            .get({},
                "get_parent_branch_business"
            )
            .before("get_parent_branch_business", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (previous_res.business && parseInt(previous_res.business.is_branch_of_id) > 0) {
                    return {
                        business: {
                            _w: [
                                ["id", "e", previous_res.business.is_branch_of_id]
                            ]
                        }
                    };
                }
                return "skip";
            })
            .send()
            .then(res => {
                //console.log("Results are here: ", res);
                if (success) {
                    var b_res = res[0].response;
                    var p_branch = null;
                    if (res[1].response._skipped && res[1].response._skipped == true) {
                        //do nothing for now
                    } else {
                        p_branch = res[1].response.business;
                    }
                    success({
                        ...b_res.business,
                        belongings: b_res.belongings,
                        business_holliday_schedules: b_res.business_holliday_schedules,
                        pictures: b_res.pictures,
                        reviews: b_res.reviews,
                        ratings: b_res.ratings,
                        products: b_res.products,
                        services: b_res.services,
                        business_messages: b_res.business_messages,
                        parent_branch: p_branch,
                        app_holidays: b_res.hollidays
                    });
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            name:"";
            description:"";
            business_id: 0,
        }
    */
    /* eslint-disable no-unused-vars */
    post_business_product(query, success, fail) {
        bee.que()
            .post({
                product: query
            })
            .get({
                products: {
                    _w: [
                        ["business_id", "e", query.business_id]
                    ]
                }
            })
            .send()
            .then(res => {
                //console.log("Itemss ", res);
                if (success) {
                    success(res[1].response.products);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            id:"";
            business_id: 0,
        }
    */
    /* eslint-disable no-unused-vars */
    delete_business_product(query, success, fail) {
        bee.que()
            .delete({
                product: {
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            })
            .get({
                products: {
                    _w: [
                        ["business_id", "e", query.business_id]
                    ]
                }
            })
            .send()
            .then(res => {
                if (success) {
                    success(res[1].response.products);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            name:"";
            description:"";
            business_id: 0,
        }
    */
    /* eslint-disable no-unused-vars */
    post_business_service(query, success, fail) {
        bee.que()
            .post({
                service: query
            })
            .get({
                services: {
                    _w: [
                        ["business_id", "e", query.business_id]
                    ]
                }
            })
            .send()
            .then(res => {
                //console.log("Itemss ", res);
                if (success) {
                    success(res[1].response.services);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            id:"";
            business_id: 0,
        }
    */
    /* eslint-disable no-unused-vars */
    delete_business_service(query, success, fail) {
        bee.que()
            .delete({
                service: {
                    _w: [
                        ["id", "e", query.id]
                    ]
                }
            })
            .get({
                services: {
                    _w: [
                        ["business_id", "e", query.business_id]
                    ]
                }
            })
            .send()
            .then(res => {
                if (success) {
                    success(res[1].response.services);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            user_id:0;
            business_id: 0,
            rate: 0
        }
    */
    /* eslint-disable no-unused-vars */
    post_business_rate(query, success, fail) {
        var new_rate_temp = 0;
        bee.que()
            .get({
                ratings: {
                    _w: [
                        [
                            ["business_id", "e", query.business_id],
                            "AND",
                            ["user_id", "e", query.user_id]
                        ]
                    ]
                }
            }, "check_previous_rating")
            .post({
                rating: {
                    ...query,
                    _date_posted_on: "",
                    _now_posted_on_timestamp: ""
                }
            }, "post_rate")
            .before("post_rate", (index, previous_res, tasks) => {
                var ratings = previous_res.ratings;
                if (ratings.length > 0) {
                    //means i previously rated this business
                    //so I can skip this step
                    return "skip";
                }
                return tasks[index].nectar;
            })
            .update({
                rating: {
                    ...query,
                    _w: [
                        [
                            ["business_id", "e", query.business_id],
                            "AND",
                            ["user_id", "e", query.user_id]
                        ]
                    ]
                }
            }, "update_rates_rate")
            .before("update_rates_rate", (index, previous_res, tasks) => {
                //if the previous task of posting was skipped
                //then execute this one to update the rate, other wise
                //skip it cause we just made a posting
                if (previous_res._skipped && previous_res._skipped == true) {
                    return tasks[index].nectar
                } else {
                    return "skip";
                }
            })
            .get({
                ratings: {
                    _w: [
                        ["business_id", "e", query.business_id]
                    ]
                }
            }, "get_ratings")
            .update({}, "update_rate")
            .before("update_rate", (index, previous_res, tasks) => {
                var ratings = previous_res.ratings;
                var total = 0;
                for (var index = 0; index < ratings.length; index++) {
                    var rating = ratings[index];
                    total = total + parseFloat(rating.rate);
                }
                var new_rate = 0;
                if (total <= 0) {
                    new_rate = 0;
                } else if (total <= 65) {
                    new_rate = 1;
                } else if (total <= 175) {
                    new_rate = 2;
                } else if (total <= 375) {
                    new_rate = 3;
                } else if (total <= 650) {
                    new_rate = 4;
                } else if (total > 650) {
                    new_rate = 5;
                }
                new_rate_temp = new_rate;
                return {
                    business: {
                        rating: new_rate,
                        _w: [
                            ["id", "e", query.business_id]
                        ]
                    }
                };
            })
            .send()
            .then(res => {
                //console.log("Itemss ", res);
                //send notifications and sms or emails
                var message_data = {
                    _box: {
                        user_id: query.user_id,
                        business_id: query.business_id,
                        new_rate: new_rate_temp,
                        rate: query.rate
                    },
                    _f_br: "send_rated_success_messages"
                }
                bee.get(message_data).then(res2 => {
                    console.log("sent the business rate notification successfully: ", res2);
                }).catch(errors_msg => {
                    console.log("Business was rated but faced errors while sending them messages: ", errors_msg);
                });
                if (success) {
                    success(res[0].response.rating);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            user_id:0;
            id: 0,
            district_id: 0,
            city_id: 0,
            ward_id: 0,
            street_id: 0,
            manual_directions: "",
            physical_address: "",
            lat: 0,
            lng: 0,
        }
    */
    /* eslint-disable no-unused-vars */
    update_business_location(query, success, fail) {
        bee.update({
            business: {
                district_id: query.district_id,
                city_id: query.city_id,
                ward_id: query.ward_id,
                street_id: query.street_id,
                manual_directions: query.manual_directions,
                physical_address: query.physical_address,
                lat: query.lat,
                lng: query.lng,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        })
            .then(res => {
                //console.log("Itemss ", res);
                if (success) {
                    success(res.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /* eslint-disable no-unused-vars */
    update_weekly_schedule(query, success, fail) {
        var data = {
            ...query
        };
        delete data.id;
        bee.update({
            business: {
                ...data,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        })
            .then(res => {
                if (success) {
                    success(res.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /* eslint-disable no-unused-vars */
    update_holidays_schedule(query, success, fail) {
        //here we need to delete the previous entries first
        bee
            .que()
            .delete({
                business_holliday_schedules: {
                    _w: [
                        ["business_id", "e", query.id]
                    ]
                }
            }, "dele_old_entries")
            .post({
                business_holliday_schedules: query.data
            }, "insert_schedules")
            .send()
            .then(res => {
                if (success) {
                    success(res[1].response.business_holliday_schedules);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /* eslint-disable no-unused-vars */
    update_business_contacts(query, success, fail) {
        bee.update({
            business: {
                office_phone_number1: query.office_phone_number1,
                mobile_phone_number1: query.mobile_phone_number1,
                email_address_1: query.email_address_1,
                website_1: query.website_1,
                fax_number: query.fax_number,
                pobox_number: query.pobox_number,
                facebook_link: query.facebook_link,
                twitter_link: query.twitter_link,
                instagram_link: query.instagram_link,
                youtube_link: query.youtube_link,
                linked_link: query.linked_link,
                whatsapp_link: query.whatsapp_link,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        })
            .then(res => {
                //console.log("Itemss ", res);
                if (success) {
                    success(res.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
    var query = {
        user_id: 0,
        business_id: 0,
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        message: ""
    }
*/
    /* eslint-disable no-unused-vars */
    send_message(query, success, fail) {
        bee.post({
            business_message: {
                ...query,
                is_read: 0,
                is_read_by_id: 0,
                read_on: "1989-01-01",
                _time_read_on_timestamp: "1989-01-01"
            }
        })
            .then(res => {
                if (success) {
                    var message_data = {
                        _box: {
                            user_id: query.user_id,
                            business_id: query.business_id,
                            first_name: query.first_name,
                            last_name: query.last_name,
                            phone_number: query.phone_number,
                            email: query.email
                        },
                        _f_br: "send_owner_received_messages"
                    }
                    bee.get(message_data).then(res2 => {
                        console.log("sent the business message notification successfully: ", res2);
                    }).catch(errors_msg => {
                        console.log("Business was sent a message but faced errors while sending them notifications: ", errors_msg);
                    });
                    success(res.business_message);
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    post_business_photo(query, success, fail) {
        bee.post({
            picture: {
                description: query.description,
                business_id: query.business_id,
                media_url: query.picture
            }
        })
            .then(res => {
                if (success) {
                    success(res.picture);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /* eslint-disable no-unused-vars */
    update_business_photo_description(query, success, fail) {
        bee.update({
            picture: {
                description: query.description,
                _w: [
                    ["id", "e", query.id]
                ]
            }
        })
            .then(res => {
                if (success) {
                    success(res.picture);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /* eslint-disable no-unused-vars */
    delete_business_photo(query, success, fail) {
        bee.delete({
            picture: {
                _w: [
                    ["id", "e", query.id]
                ]
            }
        })
            .then(res => {
                if (success) {
                    success(res.picture);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            user_id:0;
            business_id: 0,
            tags: ""
        }
    */
    /* eslint-disable no-unused-vars */
    update_business_tags(query, success, fail) {
        bee.update({
            business: {
                tags: query.tags,
                _w: [
                    ["id", "e", query.id],
                ]
            }
        })
            .then(res => {
                if (success) {
                    success(res.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            user_id:0;
            business_id: 0,
            comment: ""
        }
    */
    /* eslint-disable no-unused-vars */
    post_business_review(query, success, fail) {
        bee
            .que()
            .post({
                review: {
                    user_id: query.user_id,
                    business_id: query.business_id,
                    comment: query.comment,
                    _date_posted_on: "",
                    _now_posted_on_timestamp: ""
                }
            }, "send_review")
            .get({
                reviews: {
                    _a: "_count",
                    _w: [
                        ["business_id", "e", query.business_id]
                    ]
                }
            }, "get_nowella")
            .update({}, "update_count")
            .before("update_count", (index, previous_res, tasks) => {
                var num = previous_res.reviews[0].count;
                return {
                    business: {
                        reviews_count: num,
                        _w: [
                            ["id", "e", query.business_id]
                        ]
                    }
                };
            })
            .send()
            .then(res => {
                if (success) {
                    var message_data = {
                        _box: {
                            user_id: query.user_id,
                            business_id: query.business_id
                        },
                        _f_br: "send_reviewed_success_messages"
                    };
                    bee.get(message_data).then(res2 => {
                        console.log("sent the business review notification successfully: ", res2);
                    }).catch(errors_msg => {
                        console.log("Business was sent a review but faced errors while sending them notifications: ", errors_msg);
                    });
                    success(res[1].response.review);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            id: 0,
            data: [...]
        }
    */
    /* eslint-disable no-unused-vars */
    update_business_banner(query, success, fail) {
        bee
            .update({
                business: {
                    banner: query.banner,
                    _w: [
                        ["id", "e", query.id],
                    ]
                }
            })
            .then(res => {
                if (success) {
                    success(res.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        var query = {
            id: 0,
            data: [...]
        }
    */
    /* eslint-disable no-unused-vars */
    update_business_verifications(query, success, fail) {
        bee
            .update({
                business: {
                    ...query.data,
                    is_verified: 1,
                    _w: [
                        ["id", "e", query.id],
                    ]
                }
            }, "update_doc")
            .then(res => {
                if (success) {
                    //send a message to the people concerned
                    var message_data = {
                        _box: {
                            business_id: query.business_id
                        },
                        _f_br: "send_uploaded_verification_messages"
                    };
                    bee.get(message_data).then(res2 => {
                        console.log("sent the business verification notification successfully: ", res2);
                    }).catch(errors_msg => {
                        console.log("Business uploaded a verification document but we faced errors while sending them notifications: ", errors_msg);
                    });
                    success(res.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /* eslint-disable no-unused-vars */
    get_contact_messages(query, success, fail) {
        bee.get(
            {
                business_messages: {
                    _a: "id business_id email message is_read time_inserted",
                    _desc: ["id"],
                    business: {
                        _a: "id name"
                    },
                    _w: [
                        ["owner_id", "e", query.owner_id]
                    ]
                }
            }
        ).then(res => {
            if (success) {
                success(res.business_messages);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        })
    },
    /*
        query = {
            id: 4
        }
    */
    /* eslint-disable no-unused-vars */
    get_contact_message(query, success, fail) {
        bee
            .que()
            .get(
                {
                    business_message: {
                        _a: "id business_id first_name last_name email phone_number message is_read is_read_by_id read_on read_on_timestamp time_inserted",
                        business: {
                            user: {},
                            district: {},
                            city: {},
                            ward: {},
                            street: {}
                        },
                        _w: [
                            ["id", "e", query.id]
                        ]
                    }
                }, "get_message")
            .get({},
                "get_parent_branch_business"
            )
            .before("get_parent_branch_business", (index, previous_res, tasks) => {
                //console.log("previous_res", previous_res);
                if (parseInt(previous_res.business_message.business.is_branch_of_id) > 0) {
                    return {
                        business: {
                            _w: [
                                ["id", "e", previous_res.business_message.business.is_branch_of_id]
                            ]
                        }
                    };
                }
                return "skip";
            })
            .send()
            .then(res => {
                if (success) {
                    var b_res = res[0].response;
                    var p_branch = null;
                    if (res[1].response._skipped && res[1].response._skipped == true) {
                        //do nothing for now
                    } else {
                        p_branch = res[1].response.business;
                    }
                    b_res.business_message.business["parent_branch"] = p_branch;
                    success(b_res.business_message);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            })
    },
    /*
        var query = {
            owner_id: 0,
            user_id: 0,
            business_id: 0,
            first_name: "",
            last_name: "",
            email: "",
            phone_number: "",
            message: ""
        }
    */
    /* eslint-disable no-unused-vars */
    send_message(query, success, fail) {
        bee.post({
            business_message: {
                ...query,
                is_read: 0,
                is_read_by_id: 0,
                read_on: "1989-01-01",
                _time_read_on_timestamp: "1989-01-01"
            }
        })
            .then(res => {
                if (success) {
                    success(res.business_message);
                    //nyd
                    //tell the admin that you have a new message on contact us
                    //both via sms and email address
                }
            })
            .catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    /*
        query = {
            id: 4
        }
    */
    /* eslint-disable no-unused-vars */
    update_contact_message(query, success, fail) {
        var up = {
            business_message: {
                ...query,
                _w: [
                    ["id", "e", query.id]
                ]
            },
            // _sql:{}
        };
        delete up.business_message.id;
        bee.update(up).then(res => {
            if (success) {
                success(res.business_message);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        })
    },
    /* eslint-disable no-unused-vars */
    get_registered_buinesses(query, success, fail) {
        bee.get({
            businesses: {
                district: {},
                _ob: ["name"]
            }
        }).then(res => {
            if (success) {
                success(res.businesses);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /* eslint-disable no-unused-vars */
    get_buinesses_without_verification_docs(query, success, fail) {
        bee.get({
            businesses: {
                user: {},
                _ob: ["name"],
                _w: [
                    [
                        [
                            [
                                [
                                    ["doc_idcopy_url","e",""],
                                    "AND",
                                    ["doc_cert_incoporation_url","e",""]
                                ],
                                "AND",
                                ["doc_extr_comp_document_url","e",""]
                            ],
                            "AND",
                            ["doc_cert_tax_url","e",""]
                        ],
                        "AND",
                        ["doc_trade_liscence_url","e",""]
                    ],
                    "AND",
                    ["doc_registration_cert_url","e",""]
                ]
            }
        }).then(res => {
            if (success) {
                success(res.businesses);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /* eslint-disable no-unused-vars */
    get_buinesses_with_pending_verification(query, success, fail) {
        bee.get({
            businesses: {
                user: {},
                _ob: ["name"],
                _w: [
                    ["is_verified","e",1]
                ]
            }
        }).then(res => {
            if (success) {
                success(res.businesses);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /* eslint-disable no-unused-vars */
    get_daily_registration_report(query, success, fail) {
        bee.get({
            businesses: {
                user: {},
                _ob: ["name"],
                _w: [
                    [
                        ["joined_on_timestamp","gte",query.start_time],
                        "AND",
                        ["joined_on_timestamp","lte",query.end_time],
                    ]
                ],
                
            },
            // _sql:{}
        }).then(res => {
            if (success) {
                success(res.businesses);
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    /*
        var query = {
            id: 0,
            data: [...]
        }
    */
    /* eslint-disable no-unused-vars */
    verify_business(query, success, fail) {
        bee
            .update({
                business: {
                    verified_by_id: query.data.verified_by_id,
                    is_verified: 2,
                    _date_verified_on: "",
                    _now_verified_on_timestamp: "",
                    _w: [
                        ["id", "e", query.id],
                    ]
                }
            }, "update_verification")
            .then(res => {
                if (success) {
                    //send a message to the people concerned
                    var message_data = {
                        _box: {
                            business_id: query.business_id
                        },
                        _f_br: "send_verified_messages"
                    };
                    bee.get(message_data).then(res2 => {
                        console.log("sent the business verified notification successfully: ", res2);
                    }).catch(errors_msg => {
                        console.log("Business was verified but we faced errors while sending them notifications: ", errors_msg);
                    });
                    success(res.business);
                }
            }).catch(errors => {
                if (fail) {
                    fail(errors);
                }
            });
    },
    send_delete_message(query, success, fail) {
        var message_data = {
            _box: {
                business_id: query.business_id,
                message: query.message,
                user_id: query.user_id,
                email: query.email,
                to_name: query.to_name,
                business_name: query.business_name
            },
            _f_br: "send_delete_business_messages"
        }
        bee.get(message_data).then(res2 => {
            console.log("Deleted business by admin successfully ", res2);
            if(success){
                success(true);
            }
        }).catch(errors_msg => {
            console.log("Deleted business by admin but sending messages got issues", errors_msg);
            if(fail){
                fail();
            }
        });
    },
    post_business_view(query, success, fail) {
        var post_data = {
            owner_id: query.owner_id,
            business_id: query.id,
            context: query.context,
            page: query.page,
            section: query.section,
            view_on: query.today_str,
            _time_view_on_timestamp: query.today_str
        };
       
        var _w = [];
        if(query.user_id > 0){
            _w = [
                ["user_id","e",query.user_id],
            ];
            post_data["user_id"] = query.user_id;
        }else{
            //use ip address
            _w = [
                ["user_id","e","_fx__ipaddress_"]
            ]
            post_data["_ipaddress_user_id"] = "";
        }
        //todays date :view_on_timestamp
        _w = [
            [
                [
                    [
                        _w[0],
                        "AND",
                        ["view_on_timestamp","gte",query.start_time]
                    ],
                    "AND",
                    ["view_on_timestamp","lte",query.end_time]
                ],
                "AND",
                ["business_id","e", query.id]
            ]
        ];

        bee
        .que()
        .get({
            business_views:{
                _w: _w
            },
            // _sql:{}
        },"check_if_trucked_today")
        .post({
            business_view: post_data
        },"post_view")
        .before("post_view", (index, previous_res, tasks) => {
            //console.log("staff is real ", previous_res);
            if (parseInt(previous_res.business_views.length) > 0) {
                return "skip";
            }
            return tasks[parseInt(index)].nectar;
        }) 
        .update({
            business:{
                views_count : query.current_views_count + 1,
                _w: [
                    ["id","e",query.id]
                ]
            }
        },"update_count") 
        .before("update_count", (index, previous_res, tasks) => {
            //console.log("staff is real ", previous_res, tasks);
            if(previous_res._skipped && previous_res._skipped == true) {
                return "skip";
            }
            return tasks[parseInt(index)].nectar;
        }) 
        .send()
        .then(res => {
            // console.log("res" , res);
            if (res[1].response._skipped && res[1].response._skipped == true) {
                if (fail) {
                    fail(["This user already viwed this business today"]);
                    return;
                }
            } 
            if (success) {
                success(res[1].response.business_view);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
}